/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import s from './Footer.css';
import Link from '../Link';
import { isReleased, isHubReleased } from '../../data/widgets/release';

/**
 * Ссылки на страницы из очереди поэтапной публикации. Пока страница закрыта,
 * она отдаёт 404, поэтому ссылка на неё не должна появляться в подвале —
 * то есть на каждой странице сайта. @see src/data/widgets/release.js
 */
const STAGED_FOOTER_LINKS = [
	{
		id: '/how-to-change-new-tab',
		to: '/how-to-change-new-tab',
		label: 'Change your new tab',
	},
	{
		id: '/best-new-tab-chrome-extensions',
		to: '/best-new-tab-chrome-extensions',
		label: 'Best extensions',
	},
	{ id: 'countdown', to: '/widgets/countdown', label: 'Countdown' },
	{ id: 'todo-list', to: '/widgets/todo-list', label: 'To-do list' },
	{
		id: 'habit-tracker',
		to: '/widgets/habit-tracker',
		label: 'Habit tracker',
	},
	{ id: 'wallpaper', to: '/widgets/wallpaper', label: 'Wallpapers' },
];

export default function Footer() {
	useStyles(s);

	return (
		<footer className={s.root}>
			<div className={s.container}>
				<a
					className={s.link}
					href="https://sleekshot.app"
					target="_blank"
					rel="noopener noreferrer"
				>
					Check out our screenshot and screen capture tool -{' '}
					<b>Sleekshot</b>
				</a>
			</div>

			<nav className={s.nav}>
				{isHubReleased() && <Link to="/widgets">Widgets</Link>}
				{STAGED_FOOTER_LINKS.filter(link => isReleased(link.id)).map(
					link => (
						<Link key={link.to} to={link.to}>
							{link.label}
						</Link>
					),
				)}
				<Link to="/themes">Themes</Link>
				<Link to="/pro">PRO</Link>
				<Link to="/about">About</Link>
				<Link to="/support">Support</Link>

				<div className={s.copy}>
					New Tab Studio — a custom new tab page for Chrome, Firefox
					and Edge.
				</div>
			</nav>
		</footer>
	);
}
